export default {
  add_items: 'Dodaj produkty',
  remove_items: 'Usuń produkty',
  place_order: 'Złóż zamówienie',
  proceed_to_payment: 'Przejdź do płatności',
  go_to_menu: 'Przejdź do menu',

  toasts: {
    input_errors_found: 'W danych zamówienia wykryto błędy',
  },

  error_messages: {
    internal_error: {
      title: 'Zamówienie nieudane 😔',
      description:
        'Niestety wystąpił nieoczekiwany problem z Twoim zamówieniem — nasz zespół techniczny już nad tym pracuje 🛠️.',
    },
  },
};
